import { Component, OnInit } from '@angular/core';

import { MainService } from '../main.service';
import { Router } from '@angular/router';
import { SecurityService } from '../security.service';

@Component({
  selector: 'lib-app-home',
  templateUrl: './app-home.component.html',
  styleUrls: ['./app-home.component.css']
})
export class AppHomeComponent implements OnInit {



  selectedTab:any='dashboard'
  constructor(private router: Router,private mainService: MainService,) { }

  ngOnInit(): void {
    console.log(this.selectedTab);
    
    
  }
  selectTab(tab:string){
    this.selectedTab=tab
  }

  goToAppMaker() {
    this.router.navigate(['/app-manager']);
  }

  goToDataDictionary() {
    this.router.navigate(['/data-dictionary']);
  }
  svm_jwt:any
  goToDD(){
    let url =  this.mainService.hostWithReturnUrl.filter((item) => {
      return item.name == 'DD'
    }
    ).map(ele => {
      return ele.host
    }
    )[0]
    let ddurl = url || 'http://localhost:4400'
      const jwtString = sessionStorage.getItem('svm_jwt');
      this.svm_jwt = jwtString ? JSON.parse(jwtString) : null;
      let authenticatedurl =ddurl + "/" + "?id=" + this.svm_jwt;
    //  sessionStorage.clear();
      window.open(authenticatedurl);
    
  }

}
